import React from "react";
import { SectionPageType } from "../../types/optimizely/sectionpage";
import { HeroContainer } from "../../components/HeroContainer/HeroContainer";
import { ContentArea } from "../../components/ContentArea/ContentArea";
import { ServicesBlockWrapper } from "../../components/ServicesBlockWrapper/ServicesBlockWrapper";
import TextAndImageBlock from "../../components/TextAndImageBlock/TextAndImageBlock";
import { ArticlePageType } from "../../types/optimizely/articlePage";
import TextBlock from "../../components/TextBlock/TextBlock";
import { AnchorNav } from "../../components/AnchorNav/AnchorNav";

interface SectionPageProps {
  content: SectionPageType;
}

const removeTags = (html: string) => {
  return html.replace(/<\/?(p|h[1-6])>/gi, "");
};

const HeroModule = ({ content }: SectionPageProps) => {
  if (content?.mainImage?.expandedValue?.url) {
    return (
      <TextAndImageBlock
        name={content.name}
        description={{
          value: `<h1 class=" text-[30px] md:text-[42px] leading-[135%]">${removeTags(content.heroText.value)}</h1>`,
          propertyDataType: "PropertyXhtmlString",
          contentLink: {
            guidValue: ''
          }
        }}
        title={{
          propertyDataType: "PropertyLongString",
          value: "",
          contentLink: null,
        }}
        image={content.mainImage?.expandedValue ? {
          expandedValue: content.mainImage.expandedValue
        } : undefined}
        backgroundColor={{
          propertyDataType: "PropertyLongString",
          value: "primaryTurquoise",
        }}
        showImageOnRight={{
          propertyDataType: "PropertyBoolean",
          value: true,
        }}
        isHero={true}
      />
    )
  }
  return null;
};

const TextModule = ({ content }: SectionPageProps) => {
  if (content.bottomIntroText.value) {
    return (
      <TextBlock 
        text={{
          value: `<div class="text-2xl">${content.bottomIntroText.value}</div>`,
          propertyDataType: "PropertyXhtmlString",
          contentLink: {
            guidValue: ''
          }
        }}
        backgroundColor={{
          propertyDataType: "PropertyLongString",
          value: "primary",
        }}
        isLogoVisible={{
          propertyDataType: "PropertyBoolean",
          value: false,
        }}
        contentType={["Block", "TextBlock"]}
        contentLink={{
          id: null,
          guidValue: '',
          url: ''
        }}
        name={content.name}
        created={content.created}
      />
    )
  }
  else {
    return null;
  }
};

export const SectionPage: React.FC<SectionPageProps> = ({ content }) => {
  if (!content) {
    return <></>;
  }

  return (
    <>
      {/* Smelly fix
      Client wanted to uniform the whitespace on frontpage and other pages
      There are breadcrumbs on other pages, but not on front page  */}
      <div className="md:min-h-0 lg:min-h-[34px]" />
      <HeroModule content={content} />
      <TextModule content={content} />
      <AnchorNav content={content} />
      <ContentArea contentArea={content.mainContentArea} isFrontPage={false}/>
    </>
  );
};
